import React, { ReactNode } from 'react'
import SliderFlickityClass from './SliderFlickityClass'
import useScript from 'hooks/useScripts'
import { createGlobalStyle } from 'styled-components'
import flickityStyles from 'styles/flickity-styles'

interface SliderFlickityProps {
  children?: ReactNode
  flickityRef?: () => void
  options: any
}

const SliderFlickity: React.FC<SliderFlickityProps> = ({ children, ...rest }) => {
  const SliderFlickityClassAny = SliderFlickityClass as any
  const status = useScript('/scripts/flickity.pkgd.min.js')
  return status === 'ready' ? (
    <>
      <FlickityStyles />
      <SliderFlickityClassAny {...rest}>{children}</SliderFlickityClassAny>
    </>
  ) : null
}

const FlickityStyles = createGlobalStyle`
  ${flickityStyles}
`

export default SliderFlickity
